import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=587a79cc"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587a79cc')) {
      api.createRecord('587a79cc', component.options)
    } else {
      api.reload('587a79cc', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=587a79cc", function () {
      api.rerender('587a79cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealers-transporters/manage.vue"
export default component.exports